module.exports = __webpack_public_path__ + "img/collapse_icon_right.4ab33876.svg";